<template>
  <div>
      <metier-guide-vue>

      </metier-guide-vue>
      <!-- <utilisateur-guide-vue></utilisateur-guide-vue> -->
  </div>
</template>

<script>
import MetierGuideVue from './MetierGuide.vue'
import UtilisateurGuideVue from './UtilisateurGuide.vue'


export default {
  components: {
    MetierGuideVue,
    UtilisateurGuideVue,
  },
  directives: {

  },
  data() {
    return {
    }
  },
  computed: {
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
